export const MESSAGE_EDITOR_MENU_OPTIONS = [
  'undo',
  'redo',
  'em',
  'strong',
  'bulletList',
  'orderedList',
  'link',
  'code',
];

export const MESSAGE_SIGNATURE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'imageUpload',
];

export const ARTICLE_EDITOR_MENU_OPTIONS = [
  'strong',
  'em',
  'link',
  'undo',
  'redo',
  'bulletList',
  'orderedList',
  'h1',
  'h2',
  'h3',
  'imageUpload',
  'code',
];

export const MESSAGE_EDITOR_IMAGE_RESIZES = [
  {
    name: 'Small',
    height: '24px',
  },
  {
    name: 'Medium',
    height: '48px',
  },
  {
    name: 'Large',
    height: '72px',
  },
  {
    name: 'Original Size',
    height: 'auto',
  },
];

export const EMAIL_EDITOR_MENU_OPTIONS = [
  'undo',
  'redo',
  'fontFamily',
  'fontSize',
  'textColor',
  'em',
  'strong',
  'alignment',
  'orderedList',
  'bulletList',
  'code',
  'link',
];
